
export const TITLE = "title";
export const VALUE = "value";
export const SUBTITLE = "subtitle";
export const TYPE = "type";
export const ON_TRACK = "onTrack";
export const DELAYED = "delayed";
export const CRITICAL = "critical";
export const MAJOR = "major";
export const MINOR = "minor";
export const REWORK = "rework";
export const MAJOR_FAILURE = "majorFailure";
export const PROJECT_PLANS = "projectPlans";
export const REVISIONS = "revisions";
export const PROJECT_CLOSURE = "projectClosure";
export const PROJECT_MANAGERS = "projectManagers";
export const SITE_MANAGERS = "siteManagers";
export const SAFETY_OFFICERS = "SafetyOfficers";
export const QC_OFFICERS = "qcOfficers";
export const NAME = "name";
export const PROGRESS = "progress";
export const STATUS = "status";
export const CATEGORY = "category";
export const NOTE = "note";
export const SAFETY = "safety";
export const QUALITY = "quality";
export const EVENTS = "events";
export const VARIANCE = "variance";
export const LAST_UPDATE = "lastUpdate";
export const TASKS_COMPLETE = "tasksComplete";
export const SAFETY_AUDIT = "safetyAudit";
export const QUALITY_AUDIT = "qualityAudit";
export const TOTAL_PHOTOS = "totalPhotos";
export const PENDING_APPROVAL = "pendingApproval";
export const APPROVED = "approved";
export const REJECTED = "rejected";
export const PROJECT_LIST = "projectList";

export const bgMap: any = {
  active: "bg-white border-gray-200",
  risk: "bg-indigo-50 border-indigo-100",
  approval: "bg-yellow-50 border border-yellow-100",
  completion: "bg-green-50 border border-green-200",
  overall: "bg-green-50 border border-green-200",
  total: "bg-white border-gray-200",
  delayed: "bg-red-100 border border-red-200",
  blocked: "bg-red-100 border border-red-200",
  quality: "bg-red-100 border border-red-200"
};
